export default function clearFormFields(form) {
    let fields = form.querySelectorAll('.field')

    fields.forEach(item => {
        let fieldParent = item.parentNode
        fieldParent.classList.remove('error')
        item.value = ''
    })
}